angular.module('PatientApp').factory('EstimatesService', function($log, $resource, $q, _, $filter, endpoints, LinkedAccountsService, MoneyUtilsService, TokenService) {
    var Estimates = $resource(endpoints.estimates.primary.url, null, {
            verifyLinked: {
                method: 'POST',
                url: endpoints.estimates.verifyLinked.url
            },
            fetchFromAccount: {
                method: 'POST',
                url: endpoints.estimates.id.url,
                params: {
                    id: '@id'
                }
            },
            findNew: {
                method: 'POST',
                url: endpoints.estimates.findNew.url
            },
            link: {
                method: 'POST',
                url: endpoints.estimates.link.url
            },
            markOpened: {
                method: 'POST',
                url: endpoints.estimates.markOpened.url
            },
            firstEstimateGetCode: {
                method: 'POST',
                url: endpoints.estimates.firstEstimateGetCode.url
            }
        }),

        _estimate = null,
        EstimatesService = {
            Estimate: function(estimateServerResponse) {
                _.assign(this, estimateServerResponse);

                var _estimateSource = estimateServerResponse,
                    _paymentOptions = null;

                this.__estimate__ = _estimateSource;

                // Get the payment options that are also allowed on the
                // estimate. We consider a custom amount and the estimate amount as
                // items that will always be presented to the user.
                this.getPaymentOptions = function() {

                    if (_paymentOptions !== null) {
                        return _paymentOptions;
                    }
                    _paymentOptions = [];

                    _.map(_estimateSource.paymentOptions, function(option) {

                        var key = '',
                            translationVars = {
                                calculatedTotal: $filter('currency')(option.amount),
                                discountPolicy: option.discountPolicy
                            };

                        // Type shortcode
                        switch (option.type.toUpperCase()) {
                            case 'O': // Payment Agreement
                                key = 'payment.amount.payEstimateBal';
                                break;
                        }

                        option.dialog = $filter('translate')(key, translationVars);

                        _paymentOptions.push(option);
                    });
                    return _paymentOptions;
                };

                // get the specific details for a given payment option
                this.getPaymentOption = function(index) {
                    if (_paymentOptions === null) {
                        // hydrate the options if this
                        // is called before get paymentOptions
                        this.getPaymentOptions();
                    }
                    return _paymentOptions[index];
                };

                // get the details for the provider associated with this estimate
                this.getProviderDetails = function() {
                    return _estimateSource.providerDetails;
                };

                // get the details for the provider associated with this estimate
                this.getAccountDetails = function() {
                    return _estimateSource.accountDetails;
                };

                // we assume there is no address because there may not be a bill
                this.getGuarantorAddress = function() {
                    return null;
                };

                this.isProviderActive = function() {
                    return _estimateSource.providerDetails.active;
                };

                this.canMessageAboutEstimate = function() {
                    return this.isProviderActive() && _.includes(_estimateSource.providerDetails.features, 'messaging');
                };

                // estimates cannot be past due
                this.isPastDue = function() {
                    return false;
                };

                this.hasZeroBalance = function() {
                    return parseFloat(_estimateSource.accountBalance.amount || 0) === 0;
                };

                this.hasNegativeBalance = function() {
                    return parseFloat(_estimateSource.accountBalance.amount || 0) < 0;
                };

                // get the diff of what the estimate has vs what
                // is owed on the account
                this.balanceDiff = function() {
                    return MoneyUtilsService.subtract(_estimateSource.accountBalance.amount, _estimateSource.estimatedAmount);
                };

                this.reflectsDbu = function() {

                    if (!this.isProviderActive()) {
                        return false;
                    }

                    return _.indexOf(['dbu', 'mbu'], _.trim(_estimateSource.accountBalance.lastAction).toLowerCase()) >= 0 &&
                        !MoneyUtilsService.equals(_estimateSource.accountBalance.amount, _estimateSource.estimatedAmount);
                };

                this.hasFinancingOption = function() {
                    return this.isProviderActive() && _estimateSource.hasFinancing;
                };
            },
            createEstimate: function(estimate) {
                if (estimate instanceof EstimatesService.Estimate) {
                    return estimate;
                }
                return new EstimatesService.Estimate(estimate);
            },
            isEstimate: function(estimate) {
                return estimate instanceof EstimatesService.Estimate;
            },
            getAccountEstimate: function(id) {
                return Estimates.fetchFromAccount({ id: id }).$promise
                    .then(function(resp) {
                        if (resp && resp.hasData()) {
                            _estimate = new EstimatesService.Estimate(resp.getData());
                            return _estimate;
                        }
                        return $q.reject(resp);
                    });
            },
            getCurrentEstimate: function() {
                return _estimate;
            },
            flushCurrentEstimate: function() {
                _estimate = null;
            },
            find: function(token) {
                return TokenService.retrieve(token).then(function(resp){
                    if (resp.type === 'ESTIMATE') {
                        _estimate = new EstimatesService.Estimate(resp.data);
                        return _estimate;
                    }
                    return $q.reject(resp);
                });
            },
            markOpened: function(token){
                return Estimates.markOpened({token: token}).$promise.then(function(resp){
                    if(resp && resp.hasData()){
                        return resp.getData();
                    }
                    return $q.reject(resp);
                });
            },
            /**
             * Flow for if we link the estimate to an existing patient user beforehand
             */
            verifyLinked: function(estimate) {
                return Estimates.verifyLinked({ estimate: estimate }).$promise.then(function(resp) {
                    if (resp && resp.hasData()) {
                        return resp.getData();
                    }
                    return $q.reject(resp);
                });
            },
            /**
               Look up the estimate similar to the find method but our intent
               is also to link the estimate with the currently logged in user
            */
            link: function(estimate){
                return Estimates.link({estimate: estimate}).$promise.then(function(resp){
                    if(resp && resp.hasData()){

                        _estimate = new EstimatesService.Estimate(resp.getData());

                        // mark estimate as explicitly linked
                        _estimate.linked = true;

                        LinkedAccountsService.fetchUnverified(true); //refresh our list in case we now have a new acct connected to a new masterLink

                        return _estimate;
                    }
                    return $q.reject(resp);
                });
            },
            
            // Get verification options from firstEstimate token
            findAuthOptions: function(token) {
                return TokenService.retrieve(token).then(function(data) {
                    if (data.type === 'DFE') {
                        return data.data;
                    }
                    return $q.reject(data);
                });
            },

            findNew: function(token, verificationCode, guarantorLast4SSN, guarantorDOB, zip) {
                return Estimates.findNew({
                    token: token,
                    verificationCode: verificationCode,
                    guarantorLast4SSN: guarantorLast4SSN,
                    guarantorDOB: guarantorDOB,
                    zip: zip
                })
                .$promise.then(function(resp) {
                    if (resp && resp.hasData()){
                        _estimate = new EstimatesService.Estimate(resp.getData());
                        return _estimate;
                    }
                    return $q.reject(resp);
                });
            },

            firstEstimateGetCode: function(token) {
                return Estimates.firstEstimateGetCode({
                    estimateToken: token
                })
                .$promise.then(function(resp) {
                    if (resp && resp.hasData() && resp.getData().success === true){
                        return resp.getData();
                    }
                    return $q.reject(resp);
                });
            }
        };
    return EstimatesService;
});